import { styled, css } from '@creditas/stylitas'

interface Props {
  pendency?: boolean
  loading?: boolean
  delayed?: boolean
}

const notLoadingStyle = (props: Props) =>
  !props.loading &&
  css`
    :hover {
      border-color: #4499ee;

      > div {
        border-color: #4499ee;
      }
    }
  `

const delayedStyle = (props: Props) =>
  props.delayed &&
  css`
    background: rgba(255, 119, 17, 0.1);
    border-color: #ff7711;

    > div,
    :hover,
    :hover > div {
      border-color: #ff7711;
    }
  `

const pendencyStyle = (props: Props) =>
  props.pendency &&
  css`
    background: rgba(221, 34, 34, 0.1);
    border-color: #dd2222;

    > div,
    :hover,
    :hover > div {
      border-color: #dd2222;
    }
  `

const Card = styled.div<Props>`
  display: flex;
  position: relative;
  background-color: white;
  border: 1px solid #eeeeee;
  border-radius: 16px;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
  padding: 20px 16px 20px 25px;

  ${notLoadingStyle}
  ${delayedStyle}
  ${pendencyStyle}
`

export { Card }
